import QcSmartNotificationSettingInterface from "@app/Interface/QcSmartNotificationSettingsInterface";

export default class QcSmartNotificationSettingModel implements QcSmartNotificationSettingInterface {
    fpu: number;
    enable_qc_notification: boolean;
    enable_smart_notification: boolean;
    
    constructor(data?: QcSmartNotificationSettingInterface) {
        this.fpu = data?.fpu ?? 0;
        this.enable_qc_notification = data?.enable_qc_notification ?? false;
        this.enable_smart_notification = data?.enable_smart_notification ?? false;
    }

}